module.exports = __webpack_public_path__ + "static/media/hero-offer.6fa52800.jpg";